import { Enums } from "./enums";

export function applyRegionToUrlTemplate(
  template: string | undefined,
  regionSlug: Enums.ApiGatewayRegionSlug,
): string {
  const t = template ?? "";
  const ph = Enums.ApiGatewayRegionUrlPlaceholder.Region;
  if (!t.includes(ph)) {
    return t;
  }
  return t.split(ph).join(regionSlug);
}
